export default "__VITE_ASSET__1c493418__"